// extracted by mini-css-extract-plugin
export default {"corp-text":"CorpText_corp-text__NiW2X","corp-text__tag":"CorpText_corp-text__tag__K7p96"};